var React = require('react');

function Play (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"opacity":"0.2","cx":"40","cy":"40","r":"40","fill":"white","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M53.5718 38.6953C54.6761 39.4159 54.6761 40.5842 53.5718 41.3047L33.9995 54.0755C32.8952 54.7961 32 54.2763 32 52.9149V27.0851C32 25.7236 32.8952 25.204 33.9995 25.9245L53.5718 38.6953Z","fill":"white","key":1})]);
}

Play.defaultProps = {"width":"80","height":"80","viewBox":"0 0 80 80","fill":"none"};

module.exports = Play;

Play.default = Play;
